import React from 'react';
import PropTypes from 'prop-types';
import FlipMove from 'react-flip-move';
import { includes } from 'lodash';
import styled from 'styled-components';
import { BlogCard } from 'components/shared';
import { theme, media } from 'styles';

const Wrapper = styled(FlipMove)`
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: flex-start;

  &:after {
    content: '';
    width: calc((100% - ${parseInt(theme.sp.xl, 10) * 2}px) / 3);
  }
`;

const CardWrapper = styled.div`
  margin-bottom: ${theme.sp.max};
  width: 100%;

  ${media.tablet`
    width: calc((100% - ${parseInt(theme.sp.xl, 10)}px) / 2);
  `};
`;

const propTypes = {
  posts: PropTypes.arrayOf({}).isRequired,
  selectedCategoryId: PropTypes.string,
};

const defaultProps = {
  selectedCategoryId: undefined,
};

function List({ posts, selectedCategoryId }) {
  let selectedPosts = posts;
  const categoryId = selectedCategoryId && selectedCategoryId.split('__')[0];
  if (categoryId) {
    selectedPosts = posts.filter(p => {
      if (p.categories) {
        return includes(p.categories.map(c => c.id), categoryId);
      }
      return false;
    });
  }

  return (
    <Wrapper>
      {selectedPosts.map(post => (
        <CardWrapper key={post.id}>
          <BlogCard post={post} />
        </CardWrapper>
      ))}
    </Wrapper>
  );
}

List.propTypes = propTypes;
List.defaultProps = defaultProps;

export default List;



// WEBPACK FOOTER //
// ./src/components/BlogsPage/components/List/List.jsx